module.exports = __webpack_public_path__ + "img/icon_heart_rate_active.64c169b8.svg";